/*
 * Mikori — small client-side helpers.
 * Currently:
 * - Live-update the cart free-shipping progress meter when cart line items change.
 */
(function () {
  function formatMoney(cents) {
    var rupees = Math.max(0, Math.round(cents) / 100);
    return '₹' + rupees.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function updateProgress() {
    var bar = document.querySelector('[data-mikori-ship-progress]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    if (!threshold || isNaN(threshold)) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var current = cart.total_price || 0;
        var remaining = Math.max(0, threshold - current);
        var pct = Math.min(100, (current / threshold) * 100);
        var fill = bar.querySelector('[data-mikori-ship-fill]');
        var text = bar.querySelector('[data-mikori-ship-text]');
        if (fill) {
          fill.style.width = pct + '%';
          fill.classList.toggle('mk-ship-progress__fill--complete', pct >= 100);
        }
        if (text) {
          if (remaining > 0) {
            text.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> for free shipping';
          } else {
            text.innerHTML =
              '<span style="color: var(--mk-primary); font-weight: 600; display: inline-flex; align-items: center; gap: 5px;">' +
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>' +
              'Free shipping unlocked' +
              '</span>';
          }
        }
      })
      .catch(function () { /* ignore */ });
  }

  // Update on initial load (in case Shopify re-renders the section without us)
  document.addEventListener('DOMContentLoaded', updateProgress);

  // Hook into Dawn's PubSub if available (cart events fire on quantity change)
  if (typeof window.subscribe === 'function' && typeof window.PUB_SUB_EVENTS === 'object') {
    try {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, updateProgress);
    } catch (_) { /* noop */ }
  }

  // Fallback: also listen for any cart form submission
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.action && e.target.action.indexOf('/cart') !== -1) {
      setTimeout(updateProgress, 400);
    }
  });
})();
